module.exports = __webpack_public_path__ + "assets/img/u5e7070027341b.97e0eef0.png";